import { Country, State, City } from 'country-state-city';

const AVAILABLE_COUNTRIES = ['US', 'IN'];

export const GET_COUNTRIES = () => {
  // console.log('statee', State.getAllStates().filter(f => f?.countryCode === 'PR'))
  return Country.getAllCountries()
    .filter(f => AVAILABLE_COUNTRIES.includes(f?.isoCode))
    .map(m => {
      return { code: m?.isoCode, display: modifyCountryName(m?.name) };
    });
};

export const GET_STATES = country => {
  return State.getStatesOfCountry(country)
    .map(m => {
      if (m?.name != 'Chandigarh' && m?.name != 'Puducherry') {
        return {
          display: m?.name,
          code:
            m?.name == 'Telangana'
              ? 'TS'
              : m?.name == 'Uttarakhand'
              ? 'UK'
              : m?.name == 'Chhattisgarh'
              ? 'CG'
              : m?.isoCode,
          country: m?.countryCode,
        };
      }
    })
    ?.filter(item => item !== undefined);
};

const modifyCountryName = country => {
  if (country === 'United States') return 'US';
  return country;
};
